// import './AllAOs.scss';
import { Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { buttonStylesGreen } from '../../../Components/docsAdministrative/JsObjectStyles';
import { MaterialTableComponent } from '../../../Components/shared/ReusableSmallComponents';
import useGetRequest from '../../../hooks/useGetRequest';
import { useNumberFormatting } from '../../../hooks/useNumberFormatting';
import useWindowSize from '../../../hooks/useWindowSize';
import { formatDateJJMMYYYY } from '../../../Utils/dateFormatter';
import { getNomPrenomClearFromPersoData, getStatutAO, sortDatePublication } from '../../../Utils/utils';
//import { Button } from '@mui/material';
//import {buttonStylesGreen} from '../../../../src/Components/docsAdministrative/JsObjectStyles';
//import useWindowSize from '../../../hooks/useWindowSize';
export const countCandidatureByStatus = (candidatures) => {
    console.log(11111,candidatures);
    let retainedCount = 0;
    let interviewedCount = 0;
    let unreadCount = 0;
    if (Array.isArray(candidatures)) {
        candidatures.forEach(candidature => {
            if (candidature.status === 'retained') {
                retainedCount++;
            } else if (candidature.status === 'interview') {
                interviewedCount++;
            }
            else if (candidature.status === 'unread'){
                unreadCount++;
            }
        });
    }
    // Return an object with the counts
    return { countRetained: retainedCount, countInterviewed: interviewedCount, countUnread: unreadCount };
};
const AllAOs = () => {
    const { addEuro4Decimal } = useNumberFormatting();
    const {device}=useWindowSize();
    const { i18n } = useTranslation();
    const columns = [
        {
            field: 'aoId',
            title: i18n.t('Réf. AO'),
        },
        {
            field: 'clientId',
            title: i18n.t('Réf. Client'),
        },
        {
            field: 'nomClient',
            title: i18n.t('Nom client'),
        },
        {
            field: 'referenceInterne',
            title: i18n.t('Code int. Client'), // what we have on the exel : Réf.AO Client
        },
        {
            field: 'intitulePoste',
            title: i18n.t('Intitulé de l\'AO'),
        },
        {
            field: 'statutAo',
            title: i18n.t('Statut AO'),
        },
        {
            field: 'nbRecrutes',
            title: i18n.t('Nb. de recrutement'),
        },
        {
            field: 'dateDebutAO',
            title: i18n.t('Début publication'),
            render: (rowData) => {
                return <>
                    {formatDateJJMMYYYY(rowData?.dateDebutAO)}
                </>;
            }
        },
        {
            field: 'nbCandidatures',
            title: i18n.t('Nb. de candidatures'),
        },
        {
            field: 'countInterviewed',
            title: i18n.t('Candidatures "à interviewer"'),
        },
        {
            field: 'countRetained',
            title: i18n.t('Candidatures "Retenues"'),
        },
        {
            field: 'dateDebutMission',
            title: i18n.t('Date début Mission'),
            render: (rowData) => {
                return <>
                    {formatDateJJMMYYYY(rowData?.dateDebutMission)}
                </>;
            }
        },
        {
            field: 'dateFinMission',
            title: i18n.t('Date fin Mission'),
            render: (rowData) => {
                return <>
                    {formatDateJJMMYYYY(rowData?.dateFinMission)}
                </>;
            }
        },
        {
            field: 'localisation',
            title: i18n.t('Localisation'),
        },
        {
            field: 'dureeBDC',
            title: i18n.t('Durée du BDC'),
            render: (rowData) => {
                return addEuro4Decimal(rowData?.dureeBDC,'mois');
            }
        },
        {
            field: 'dureeMission',
            title: i18n.t('Durée Mission'),
            render: (rowData) => {
                return addEuro4Decimal(rowData?.dureeMission,'j');
            }
        },
        {
            field: 'budgetMax',
            title: i18n.t('Budget Max/j'),
        },
        {
            field: 'creePar',
            title: i18n.t('AO Créé par'),

        },
        {
            field: 'respoOper',
            title: i18n.t('Resp. opérationnel'),
        },
        {
            field: 'respoAchat',
            title: i18n.t('Resp. achat'),
        },
        {
            field: 'dateFinAO',
            title: i18n.t('Fin publication'),
            render: (rowData) => {
                return <>
                    {formatDateJJMMYYYY(rowData?.dateFinAO)}
                </>;
            }
        },
    ];
    const { data: aos, refresh } = useGetRequest({ url: '/ao/getAllAOs' });
    const [arraymission, setArraymission] = useState();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const [filtreCandidat, setFiltreCandidat] = useState(searchParams.get('filtreCandidat') === 'true');
    const [filtre, setFiltre] = useState(searchParams.get('filtre') === 'true');
    const [url, setUrl] = useState('');
    // ! when the CORS error wfixed : in case of refresh token expired
    const navigate = useNavigate();
    const [selectedRow, setSelectedRow] = React.useState(null);
    const mapAO = (ao) => {
        return {
            'aoId': ao?.aoId,
            'clientId': ao?.companyDataId?.clientId ?? ao?.esnId?.esnId,
            'nomClient': ao?.companyDataId?.profileEntreprise?.nom || ao?.esnId?.profileEntreprise?.nom,
            'referenceInterne': ao?.referenceInterne,
            'intitulePoste': ao?.intitulePoste,
            'statutAo': i18n.t(getStatutAO(ao?.dateDebutAO, ao?.dateFinAO)),
            'nbRecrutes': ao?.nbRecrutes,
            'dateDebutAO': ao?.dateDebutAO,
            'nbCandidatures': ao?.candidatures?.length,
            'countInterviewed': countCandidatureByStatus(ao?.candidatures)?.countInterviewed,
            'countRetained': countCandidatureByStatus(ao?.candidatures)?.countRetained,
            'dateDebutMission': ao?.dateDebutMission,
            'dateFinMission': ao?.dateFinMission,
            'localisation': ao?.localisation,
            'dureeBDC': ao?.dureeBDC ,
            'dureeMission': ao?.dureeMission,
            'budgetMax': ao?.tjMax ? ao?.tjMax+ ' €' :'Non précisé',
            'creePar': ao?.collaboratorId?.persoData
                ? getNomPrenomClearFromPersoData(ao?.collaboratorId?.persoData)
                : ao?.collaboratorEsnId?.persoData
                    ? getNomPrenomClearFromPersoData(ao?.collaboratorEsnId?.persoData)
                    : 'Back Office',
            'respoOper': getNomPrenomClearFromPersoData(ao?.entrepriseData?.responsableOperationnelId?.persoData ?? ao?.entrepriseData?.responsableOperationnelEsnId?.persoData),
            'respoAchat': getNomPrenomClearFromPersoData(ao?.entrepriseData?.responsableAchatId?.persoData ?? ao?.entrepriseData?.responsableAchatEsnId?.persoData),
            'dateFinAO': ao?.dateFinAO,
            ...ao,
        };
    };

    useEffect(() => {
        const currentUrl = window.location.href;
        setUrl(currentUrl);
    }, [location]);

    useEffect(() => {
        if(url && !url.toLowerCase().includes('filtrecandidat') && !url.toLowerCase().includes('filtre') ){
            setFiltreCandidat(false);
            setFiltre(false);
            refresh();
        }
    }, [url]);

    useEffect(() => {
        if (!aos) return;

        const filteredAOs = aos.reverse().filter(ao => {
            const statut = getStatutAO(ao?.dateDebutAO, ao?.dateFinAO);
            const countRetained = countCandidatureByStatus(ao?.candidatures)?.countRetained;

            return (filtre && statut === 'Publié') ||
                   (filtreCandidat && statut === 'Publié' && countRetained > 0) ||
                   (!filtre && !filtreCandidat);
        });

        setArraymission(sortDatePublication(filteredAOs.map(mapAO)));
    }, [aos, filtre, filtreCandidat]);

    return (
        <div
            className='Frame1AllAOs'
        >
            <div className='frame5Profile'>{i18n.t('Gestion des candidatures')} &gt; <span style={{color:'rgba(39, 45, 60, 1)'}}>{i18n.t('Appels d\'offres')} </span> </div>
            <div className='Frame2AllAOs'>
                <h4 className='titlesociete'>
                    {i18n.t('Appels d\'offres ouverts')}
                </h4>
            </div>
            <div className="frame12TableMissionBDCAdmin">
                <Button
                    variant="contained"
                    style={{
                        ...buttonStylesGreen(false),...{width:device=='desktop'?'auto':'100%'}
                    }}
                    onClick={() => {
                        navigate('/admin/createAO');
                    }}
                >
                    {i18n.t('Créer un AO')}
                </Button>
            </div>
            <MaterialTableComponent
                columns={columns}
                data={arraymission}
                title={i18n.t('Appels d\'offres ouverts')}
                onRowClick={(event, rowData) => {
                    navigate(`/admin/ao/${rowData?._id}`);
                    setSelectedRow(rowData?.tableData.id);
                }}
                selectedRow={selectedRow}
            />
        </div>
    );
};
export default AllAOs;
